import React, { useState, useEffect } from "react";

import SpApCmSdSummaryType from "./SummaryDashboardType/SyApCmSdSummaryType";
import { WEB_ROLE } from "../../../common/Constant";
import RORSummaryType from "./SummaryDashboardType/RORSummaryType";
import HistorianSummaryType from "./SummaryDashboardType/HistorianSummaryType";
import EditorSummaryType from "./SummaryDashboardType/EditorSummaryType";
import BillingSpecialistSummaryType from "./SummaryDashboardType/BillingSpecialistSummaryType";
import TranscriberSummaryType from "./SummaryDashboardType/TranscriberSummaryType";

interface ResultProps {
  onTabChange: () => void;
}

const AllDashBoardsDetails: React.FC<ResultProps> = ({ onTabChange }) => {
  const userRole = localStorage.getItem("userrole") || "";

  const isCaseManager = userRole.includes(WEB_ROLE.Case_Manager);
  const isAppAdmin = userRole.includes(WEB_ROLE.App_Admin);
  const isSystemAdmin = userRole.includes(WEB_ROLE.System_Admin);
  const isScheduler = userRole.includes(WEB_ROLE.Scheduler);
  const isSupervisor = userRole.includes(WEB_ROLE.Supervisor);
  const isROR = userRole.includes(WEB_ROLE.Record_Reviewer);
  const isHistorian = userRole.includes(WEB_ROLE.Historian);
  const isEditor = userRole.includes(WEB_ROLE.Editor);
  const isDoctor = userRole.includes(WEB_ROLE.QME_Doctor);
  const isIndependentDoctor = userRole.includes(WEB_ROLE.IndependentQMEDoctor);
  const isMedicalAssistant = userRole.includes(WEB_ROLE.Medical_Assistant);
  const isBilling = userRole.includes(WEB_ROLE.Billing_Specialist);
  const isTranscriber = userRole.includes(WEB_ROLE.Transcriber);
  const isPraticeManager = userRole.includes(WEB_ROLE.Practice_Manager);
  return (
    <>
      {(isCaseManager ||
        isAppAdmin ||
        isScheduler ||
        isSupervisor ||
        isDoctor ||
        isPraticeManager ||
        isIndependentDoctor ||
        isMedicalAssistant ||
        isSystemAdmin) && (
        <SpApCmSdSummaryType onTabChange={onTabChange} userRole={userRole} />
      )}
      {isROR && (
        <RORSummaryType onTabChange={onTabChange} userRole={userRole} />
      )}
      {isHistorian && (
        <HistorianSummaryType onTabChange={onTabChange} userRole={userRole} />
      )}
      {isEditor && (
        <EditorSummaryType onTabChange={onTabChange} userRole={userRole} />
      )}
      {isTranscriber && (
        <TranscriberSummaryType onTabChange={onTabChange} userRole={userRole} />
      )}
      {isBilling && (
        <BillingSpecialistSummaryType
          onTabChange={onTabChange}
          userRole={userRole}
        />
      )}
    </>
  );
};

export default AllDashBoardsDetails;
